module.exports = "<p>\n  Questa offerta in sconto fisso è <span>dedicata</span> a chi sceglie di attivare un contratto <span>online</span>. Tutto è gestito in digitale, anche l'invio della bolletta. \n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-email-modal/alg-email-modal.component.html
// module id = ./src/app/components/dialogs/alg-email-modal/alg-email-modal.component.html
// module chunks = main